import { gql } from "@apollo/client";

export const GET_UNIPAL_CONFIG = gql`
 query getUnipalConfigs($filter: UnipalConfigFilterInput, $page: PageInput!) {
      getUnipalConfigs(filter: $filter, page: $page) {
          code
          success
          message
          total_count
          unipal_configs {
              unipal_item_id 
              route_type  
              item_type   
              routes {
                  route_id
                  route_name {
                      en
                      ar
                  }
                  seat_types
                  included
              }
              trips {
                  trip_id
                  trip_name {
                      en
                      ar
                  }
                  route_id
                  time_slots
                  days_of_week
                  included
              } 
              daypasses {
                  daypass_id
                  daypass_name {
                      en
                      ar
                  }
                  included
              } 
              status_code   
              status {
                  code
                  description {
                      en
                      ar
                  }
              } 
              effective_from   
              effective_to   
              user_audit { 
                  created_by
                  created_date
                  modified_by
                  modified_date
              } 
          }
      }
  }
`